import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const { t } = useTranslation();
  
  const testimonials = t('testimonials.items', { returnObjects: true });
  
  return (
    <section className="section bg-primary-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="section-title">{t('testimonials.title')}</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial: { text: string; author: string }, index: number) => (
            <div key={index} className="card relative">
              <div className="absolute -top-4 -left-4 text-primary-200">
                <Quote size={40} />
              </div>
              
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} className="text-yellow-400 fill-current" />
                ))}
              </div>
              
              <p className="text-gray-600 mb-6 relative z-10">{testimonial.text}</p>
              
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="ml-3">
                  <p className="font-medium">{testimonial.author}</p>
                  <p className="text-sm text-gray-500">Patient</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;